<template>
  <div v-if="ir !== null">
    <h3 class="mb-5">Financial Information</h3>
    <div class="h4 mb-5">顯示於Investor Relations頁面</div>

    <!-- Title -->
    <label class="form-item d-flex pa-5">
      <div class="w-174px mr-6px"><h4>Title</h4></div>
      <div class="flex-grow-1 my-n2">
        <v-text-field
          v-model="ir.financial_information_title"
          outlined
          dense
        ></v-text-field>
      </div>
    </label>
    <!-- img uploader -->
    <div class="form-item d-flex px-5 py-5">
      <div class="w-180px">
        <h4 class="mb-10px">Picture</h4>
        <div class="h5 ink-02-medium--text">
          建議尺寸：999px * 999px <br />
          檔案大小限制：&lt; 1 MB
        </div>
      </div>
      <div class="d-flex justify-end flex-grow-1">
        <ImgUploader
          :imageUrl.sync="ir.financial_information_pic"
          dir="ir"></ImgUploader>
      </div>
    </div>

    <h3 class="mb-5 mt-5">Tabs</h3>
    <div class="h4 mb-5">設定多語系按鈕、頁籤用</div>
    <!-- Items -->
    <div>
      <div
        class="form-item d-flex pt-3 align-center"
        v-for="(item, i) in ir.financial_tabs"
        :key="i"
      >
        <div class="w-180px">
          <h4 class="mb-30px">{{ typeName(item.type) }}</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div class="d-flex">
            <v-text-field
              v-model="item.title"
              row-height="7"
              auto-grow
              outlined
              dense
            ></v-text-field>
            <button class="btn square ml-10px" @click="downItem(item, i)">
              <v-icon>arrow_downward</v-icon>
            </button>
            <button class="btn square ml-10px" @click="upItem(item, i)">
              <v-icon>arrow_upward</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
  },
  data: () => ({
    tabs: [{
      type: 1,
      title: '每月營收報告',
    }, {
      type: 2,
      title: '每季營運報告',
    }, {
      type: 3,
      title: '財務報告書',
    }, {
      type: 4,
      title: '公司年報',
    }],
  }),
  methods: {
    typeName(type) {
      const tab = this.tabs.find((o) => o.type === type);
      return tab.title;
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.ir.financial_tabs.length - 1) {
        this.ir.financial_tabs.splice(i, 1);
        this.ir.financial_tabs.unshift(item);
        return;
      }
      // item become next index
      this.ir.financial_tabs.splice(i, 1);
      this.ir.financial_tabs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.ir.financial_tabs.splice(i, 1);
        this.ir.financial_tabs.push(item);
        return;
      }
      // item become previous index
      this.ir.financial_tabs.splice(i, 1);
      this.ir.financial_tabs.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
